import React from "react";
const classnames = require('classnames')

type Props = {
    lists:Array<string>,
    active:number
}

const Steps:React.FC<Props> = (props) => {

    return <div className="steps">
        {
            props.lists.map((item,index) => {
                return <div className={classnames("step",{ "active": props.active >= index })} key={index}>
                    <p className="n">{ index + 1 }</p>
                    <p className="s">{ item }</p>
                </div>
            })
        }
    </div>
}

export default Steps
